module.exports = __webpack_public_path__ + "img/openMap.1d99dc81.svg";